export const CHANGE_PASSWORD_FORM_ID = 'changePasswordForm';
